module.exports = __webpack_public_path__ + "img/COM-A-3-III.e7e32c46.png";